module.exports = __webpack_public_path__ + "img/horizon-01.9f52ab37.png";